import React, { useState } from "react";

const TodoInputGroup = ({ onCreate }) => {
  const defaultTodo = {
    goal: "", 
    purpose: "", 
    todo: "",
    timing: "",
  };

  const [list, setList] = useState(defaultTodo);

  const handleCreate = () => {
    onCreate && onCreate(list)
      .then(() => {
        setList(defaultTodo); // 清空輸入欄位
      })
      .catch(() => {
        alert("Failed!");
      });
  };

  return (
    <div className="input-group mb-3">
      <input
        value={list.goal}
        onChange={(e) =>
          setList({
            ...list,
            goal: e.target.value
          })
        }
        type="text"
        className="form-control"
        placeholder="Goal"
      />
      <input
        value={list.purpose}
        onChange={(e) =>
          setList({
            ...list,
            purpose: e.target.value
          })
        }
        type="text"
        className="form-control"
        placeholder="Purpose"
      />
      <input
        value={list.todo}
        onChange={(e) =>
          setList({
            ...list,
            todo: e.target.value
          })
        }
        type="text"
        className="form-control"
        placeholder="To-do"
      />
      <input
        value={list.timing}
        onChange={(e) =>
          setList({
            ...list,
            timing: e.target.value
          })
        }
        type="text"
        className="form-control"
        placeholder="Timing"
      />
      <button className="btn btn-success" onClick={handleCreate}>Add</button>
    </div>
  );
};

export default TodoInputGroup;
